import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";

import Checkout from "./pages/Checkout";
import NotFound from "pages/NotFound";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/invoice/:id" component={Checkout}></Route>
        <Route path="/" component={NotFound}></Route>
      </Switch>
    </Router>
  );
}

export default App;
